<div id="loader" class="spin-wrapper">
    <div class="spinner">
        <div class="spinningCircle"></div>
        <div class="text">Loading...</div>
    </div>
</div>
<div class="page-content">
	<router-outlet></router-outlet>
</div>